import './INF.css';
import React from "react";
import Footer from './Footer'
import Slideshow from './Slideshow'
import Carousel from './Carousel'
import ClosingMessage from './ClosingMessage'
import welcome from './assets/welcome.svg'

function INF() {

    return (
        <div class="INF">
        <img className="logoFull" src={welcome} alt="welcome to instant noodle factory"></img>
        <ClosingMessage />
        <Slideshow/>
        <Carousel />
        <Footer />
        </div>
    )
}

export default INF;